import { GameManager } from "../Managers/GameManager";
import { DataManager } from "../Managers/DataManager";
import { ModuleManager } from "../Managers/ModuleManager";
import { Scaling } from "./Scaling";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";

/**
 * @class CustomUtils
 */
export class CustomUtils {
    public static SymbolBonus: number = 8;
    public static SymbolBonusMini: number = 9;
    public static SymbolBonusMinor: number = 10;
    public static SymbolBonusMajor: number = 11;
    public static SymbolEmpty: number = 12;

    public static readonly MultiplierAnimationDuration: number = 135; //in frames

    static isRespin(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0
        );
    }

    /**
     * Indicates that respin was triggered.
     * @returns {boolean}
     */
    static isRespinEnabled(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId === 0
        );
    }

    /**
     * Indicates that respin is in progress.
     * @returns {boolean}
     */
    static isRespinActive(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    /**
     * Indicates that last respin round is in progress.
     * @returns {boolean}
     */
    static isRespinLast(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin === 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    /**
     * Indicates that last bonus round is in progress.
     * @returns {boolean}
     */
    static isLastBonusSpin(limitCallback?: () => void): boolean {
        if (DataManager.GameLimit) {
            if (limitCallback != null) {
                limitCallback();
            }
            return true;
        }
        return (
            GameManager.bonusRespinsResponse.bonusRespins != null &&
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount != null &&
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount === 0 &&
            GameManager.bonusRespinsResponse.respin == 0 &&
            GameManager.bonusRespinsResponse.spinId > -1
        );
    }

    static getRemainingRespins(): number {
        if (
            GameManager.bonusRespinsResponse.bonusRespins != null &&
            GameManager.bonusRespinsResponse.bonusRespins.remainingCount != null
        ) {
            return GameManager.bonusRespinsResponse.bonusRespins.remainingCount;
        }

        return 0;
    }

    static isBonusSymbol(symbolId: number): boolean {
        return symbolId >= CustomUtils.SymbolBonus && symbolId <= CustomUtils.SymbolBonusMajor;
    }

    static isBonusSymbolInArray(symbolIds: Array<number>): boolean {
        for (let i = 0; i < symbolIds.length; i++) {
            if (symbolIds[i] >= CustomUtils.SymbolBonus && symbolIds[i] <= CustomUtils.SymbolBonusMajor) {
                return true;
            }
        }

        return false;
    }

    static isBonusRespin(): boolean {
        return (
            GameManager.bonusRespinsResponse != null &&
            GameManager.bonusRespinsResponse.respin != null &&
            GameManager.bonusRespinsResponse.respin !== 0
        );
    }

    /**
     * Indicates that respin was triggered.
     * @returns {boolean}
     */
    static isBonusRespinEnabled(): boolean {
        return (
            GameManager.bonusRespinsResponse != null &&
            GameManager.bonusRespinsResponse.respin != null &&
            GameManager.bonusRespinsResponse.respin !== 0 &&
            GameManager.bonusRespinsResponse.spinId === 0
        );
    }

    /**
     * Indicates that respin is in progress.
     * @returns {boolean}
     */
    static isBonusRespinActive(): boolean {
        return (
            GameManager.bonusRespinsResponse != null &&
            GameManager.bonusRespinsResponse.respin != null &&
            GameManager.bonusRespinsResponse.respin !== 0 &&
            GameManager.bonusRespinsResponse.spinId > 0
        );
    }

    /**
     * Indicates that last respin round is in progress.
     * @returns {boolean}
     */
    static isBonusRespinLast(): boolean {
        return (
            GameManager.bonusRespinsResponse != null &&
            GameManager.bonusRespinsResponse.respin != null &&
            GameManager.bonusRespinsResponse.respin === 0 &&
            GameManager.bonusRespinsResponse.spinId > 0
        );
    }

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }

    /**
     *
     * @param src
     * @param childName
     * @param dest
     */
    static swapChilds(src: BaseElement, childName: string, dest: any): void {
        if (src != null && dest.childs[childName] != null) {
            dest.addChildAt(src, dest.getChildIndex(dest.childs[childName]));
        }
    }

    public static getObjectFrom(objName: string, source: any, tp?: any): any {
        if (source[objName] != null) {
            if (tp != null) {
                if (source[objName] instanceof tp) {
                    return source[objName];
                }
            } else {
                if (source[objName]) {
                    return source[objName];
                }
            }
        }

        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/